import { NavigationBar } from "@bbnpm/bb-ui-framework";
import styled from "styled-components";

export const StyledNavigationBar = styled(NavigationBar)`
  border-bottom: 0;
`;

export const StyledHeader = styled.div`
  width: 100%;
  z-index: 3;
  top: 0;
  &:after {
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    background: #007bff;
    background: linear-gradient(to right, #007bff, #ff0c3e);
  }
`;
